import * as s from "./mockup-macbook.module.less";
import React from "react";
import MacbookImage from "../../../media/mockups/macbook.png"
import {GatsbyImage as Img, getImage} from "gatsby-plugin-image";

const MockupMacbook = ({
	screenShot,
	companyName
}) => {
	return (
		<div className={s.mockup}>
			<img
				src={MacbookImage}
				alt={`${companyName} media`}
				className={s.mockImage}
			/>
			<div
				className={s.mediaElement}
			>
				<Img
					image={getImage(screenShot)}
					alt={`${companyName} media`}
				/>
			</div>
		</div>
	)
}
export default MockupMacbook;
